// src/API/basic/agendamento/Deletar.js
import { nodeRedApi } from '../../../services/axios';

export async function Deletar(grupo, inicio) {
  // axios já envia JSON e seta Content-Type automaticamente
  const response = await nodeRedApi.post('/agenda/delete', { grupo, inicio });

  // equivalente ao "return response" do fetch
  return response;
}
